import { loadVidstack } from '../../utils/vidstack';
import { observeMediaElement } from '../../utils/mediaTelemetry';

export default class CollectionCardsHighlight {
  constructor(el) {
    this.el = el;

    this.init();
  }

  init() {
    // <video data-src> (mp4/webm) plays via the global background-video
    // catch-all (src/js/utils/bgVideo.js, mountBgVideos()).
    this.el.querySelectorAll('media-player, video').forEach((player, index) => {
      if (player.tagName === 'MEDIA-PLAYER') loadVidstack();
      observeMediaElement(player, {
        context: 'collection-cards-highlight',
        kind: `side-${index}`,
        src: player.getAttribute('src') || player.dataset.src,
      });
    });

    this.sides = this.el.querySelectorAll('.c-collection-cards-highlight__side');

    this.sides.forEach((side) => {
      side.addEventListener('mouseenter', () => {
        this.sides.forEach((s) => s.classList.remove('is-active'));
        side.classList.add('is-active');
      });
    });
  }
}
